// @flow

// Initial Store for sections
import initialStore from "@src/initialStore";

// Constants
import {
  SET_CLIENT_INFO,
  TOGGLE_INDICATOR,
  TOGGLE_RATING,
  TOGGLE_CONTRIBUTING,
  ADD_RATING,
  ADD_CONTRIBUTING,
  CALCULATE_RISK_SCORE,
  UPDATE_COMMENT,
  CLEAR_EVERYTHING
} from "@src/actions";

//Pure copy for restarting to initial state
const initialStoreCopy = JSON.parse(JSON.stringify(initialStore));

// Section Reducer
export default function sections(state = initialStore, action) {
  switch (action.type) {
    case SET_CLIENT_INFO:
      return {
        ...state,
        id: action.id,
        name: action.name,
        careType: action.careType,
        assessmentType: action.assessmentType,
        showAssessment: action.showAssessment
      };
    case TOGGLE_INDICATOR:
      let newIndicatorSubsections = state.sections.riskindicators.subsections.slice();
      newIndicatorSubsections[action.index].behaviours[
        action.key
      ].checked = !newIndicatorSubsections[action.index].behaviours[action.key]
        .checked;
      return {
        ...state,
        sections: {
          ...state.sections,
          riskindicators: {
            ...state.sections.riskindicators,
            subsections: newIndicatorSubsections
          }
        }
      };
    case TOGGLE_RATING:
      let newRisks = state.sections.riskratings[state.careType].risks.slice();
      newRisks[state.riskScore].measures[action.key].checked = !newRisks[
        state.riskScore
      ].measures[action.key].checked;
      return {
        ...state,
        sections: {
          ...state.sections,
          riskratings: {
            ...state.sections.riskratings,
            [state.careType]: {
              ...state.sections.riskratings[state.careType],
              risks: newRisks
            }
          }
        }
      };
    case TOGGLE_CONTRIBUTING:
      let newContributingSubsections = state.sections.contributingfactors.subsections.slice();
      newContributingSubsections[action.index].factors[
        action.key
      ].checked = !newContributingSubsections[action.index].factors[action.key]
        .checked;
      return {
        ...state,
        sections: {
          ...state.sections,
          contributingfactors: {
            ...state.sections.contributingfactors,
            subsections: newContributingSubsections
          }
        }
      };
    case ADD_RATING:
      let newAddRisks = state.sections.riskratings[
        state.careType
      ].risks.slice();
      newAddRisks[state.riskScore].measures[action.key] = {
        checked: false,
        text: action.value
      };
      return {
        ...state,
        sections: {
          ...state.sections,
          riskratings: {
            ...state.sections.riskratings,
            [state.careType]: {
              ...state.sections.riskratings[state.careType],
              risks: newAddRisks
            }
          }
        }
      };
    case ADD_CONTRIBUTING:
      let newAddContributingSubsections = state.sections.contributingfactors.subsections.slice();
      newAddContributingSubsections[action.index].factors[action.key] = {
        checked: false,
        text: action.value
      };
      return {
        ...state,
        sections: {
          ...state.sections,
          contributingfactors: {
            ...state.sections.contributingfactors,
            subsections: newAddContributingSubsections
          }
        }
      };
    case CALCULATE_RISK_SCORE:
      let riskTotal = 0;
      state.sections.riskindicators.subsections.forEach(subsection => {
        Object.values(subsection.behaviours).forEach(behaviour => {
          if (behaviour.checked) {
            riskTotal += 1;
          }
        });
      });
      let riskScore = [0, 3, 5, 12].findIndex(maxRiskForLevel => {
        return riskTotal <= maxRiskForLevel;
      });
      return {
        ...state,
        riskScore
      };
    case UPDATE_COMMENT:
      const hasSubsections = Boolean(
        state.sections[action.section].subsections
      );
      let newSection = hasSubsections
        ? {
            ...state.sections[action.section],
            subsections: state.sections[action.section].subsections.slice()
          }
        : { ...state.sections[action.section], comments: action.value };
      if (hasSubsections) {
        newSection.subsections[action.index].comments = action.value;
      }
      return {
        ...state,
        sections: {
          ...state.sections,
          [action.section]: newSection
        }
      };
    case CLEAR_EVERYTHING:
      return {
        ...initialStoreCopy,
        sections: {
          ...initialStoreCopy.sections
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/app/index.js